import VentesStocks from './VentesStocks.view';

export default VentesStocks;
